'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { THEMES } from '../../ui-components/PlayBadge/PlayBadge';
import { Badge } from './OpenArchiveBadge.styles';

const OpenArchiveBadge = ({ openArchive, location, theme, className }) => {
    if (!openArchive) {
        return null;
    }

    /* No badges on genre/oppet-arkiv */
    if (location && location.pathname.includes('oppet-arkiv')) {
        return null;
    }

    return <Badge text="Öppet Arkiv" accessibilityText="Öppet Arkiv" theme={theme} className={className} />;
};

OpenArchiveBadge.propTypes = {
    openArchive: PropTypes.bool,
    location: PropTypes.object,
    theme: PropTypes.oneOf([THEMES.DEFAULT, THEMES.OPEN_ARCHIVE_SMALL]),
};

export default OpenArchiveBadge;
